import { ContentType } from '@standardnotes/domain-core';
import { ComponentArea } from '../../Component/ComponentArea';
export function FillThemeComponentDefaults(theme) {
    if (!theme.index_path) {
        theme.index_path = 'index.css';
    }
    theme.content_type = ContentType.TYPES.Theme;
    if (!theme.area) {
        theme.area = ComponentArea.Themes;
    }
    return theme;
}
